<template>
  <p v-html="$t('errors.forbidden_login_2')" />
</template>

<script>
export default {
    name: 'LoginError'
};
</script>

<style scoped></style>
